// ABOUTME: Input/output validation schemas for TechLog → Rusada oil and fuel transformation.
import {
  ZRusadaOilAndFuelInput,
  ZRusadaOilAndFuelResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogFuelUplifts } from '../../../../types/techLog/fuel.zod';
import { ZTechLogSector } from '../../../../types/techLog/sector.zod';
import { z } from 'zod';

/**
 * Input validation schema for oil and fuel transformation.
 * Supports both FLIGHT and TRIP_UPDATES parent entities.
 */
export const ZTechLogToRusadaOilAndFuelInput = z.object({
  techlog: z.object({
    // Deviation: arrivalFuel needs the parent flight burn value, but the uplift endpoints do not provide it.
    sectorActualFuelBurn: ZTechLogSector.shape.actualFuelBurn.optional(),
    fuelUplifts: z.array(ZTechlogFuelUplifts),
  }),
  rusada: z.object({
    // Full destination state fetched from GET /v1/Flights/{flightId}/OilAndFuel.
    currentOilAndFuel: ZRusadaOilAndFuelResponse,
  }),
});

export const ZTechLogToRusadaOilAndFuelOutput = ZRusadaOilAndFuelInput;

// Type exports - inferred from Zod schemas (single source of truth)
export type TechLogToRusadaOilAndFuelInput = z.infer<
  typeof ZTechLogToRusadaOilAndFuelInput
>;
export type TechLogToRusadaOilAndFuelOutput = z.infer<
  typeof ZTechLogToRusadaOilAndFuelOutput
>;
